function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { useClassPrepend } from "../../../../hook/ui/common/className/useClassPrepend";
import { UnstyledControlledInput } from "../../input/UnstyledControlledInput";
import { UnstyledButton } from "../../button/UnstyledButton";

/*
    Returns a controlled input and a button to clear the input

    props
        (component, optional)  ControlledInputComponent       The controlled input to use for the rendered input
        (component, optional)  ClearButtonComponent           The button component to use for the clear button
        (jsx, optional)        ClearButtonComponentChildren   The children of the clear button
*/

const UnstyledTableFilterInputClearable = ({
  classPrepend = "unstyled",
  ControlledInputComponent = UnstyledControlledInput,
  ClearButtonComponent = UnstyledButton,
  ClearButtonComponentChildren = "clear",
  name,
  value,
  onChange,
  ...rest
}) => {
  const [getClassName, getClassNameWithGlobal] = useClassPrepend(classPrepend);
  const isClearDisabled = value === "";
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ControlledInputComponent, _extends({
    name: name,
    value: value,
    onChange: onChange
  }, rest)), /*#__PURE__*/React.createElement(ClearButtonComponent, _extends({}, getClassName(`table-filter-clear-button ${isClearDisabled ? "table-filter-clear-button-inactive" : ""}`), {
    onClick: () => onChange({
      name,
      value: ""
    }),
    disabled: isClearDisabled
  }), ClearButtonComponentChildren));
};
export { UnstyledTableFilterInputClearable };